import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'

const Header = ({ step, handleStepChange, description, active }) => {
  const classDisplay = step > 0 ? 'd-block' : 'd-none'

  return (
    <div className='checkout-step-profile checkout-step row px-2 border-bottom border-color-ui-3 '>
      <div className='col-auto px-1'>
        <div className='row mx-0 align-items-center h-100'>
          <Icon
            className={`${active ? 'step_icon_active' : 'step_icon_inactive'} color-brand-1`}
            iconName='icon_profile'
          />
        </div>
      </div>
      <div className='col'>
        <div className='row mx-0 align-items-center h-100'>
          { active ? <div className='col mr-auto'>
            <h1 className='active-checkout-step txt-body txt-uppercase color-brand-1'>
              Dados Pessoais
            </h1>
          </div> : (
            <div className='col mr-auto'>
              <span className='inactive-checkout-step txt-body txt-uppercase color-brand-1 h2'>
                Dados Pessoais
              </span>
              <p className={`txt-body-sm ${classDisplay}`}>{description}</p>
            </div>
          )}

          <div className='col-auto'>
            <a
              className={`txt-body-sm txt-right border-bottom border-color-ui-1 color-links border-color-links ${classDisplay}`}
              onClick={() => {
                handleStepChange(0)
              }}
              href='javascript:void(0)'
            >
              Alterar
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  step: PropTypes.number.isRequired,
  handleStepChange: PropTypes.func.isRequired,
  description: PropTypes.string,
  active: PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/features/Checkout/ProfileInfos/Header.js